import { Injectable } from '@angular/core';
import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { AppFacade } from '@app/core/app-services';

@Injectable()
export class UnauthorizedInterceptor implements HttpInterceptor {

  constructor(private appFacade: AppFacade) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next
      .handle(request)
      .pipe(catchError((err: any) => {
        if (err instanceof HttpErrorResponse && err.status === 401) {
          this.appFacade.setAuthenticated(false);
        }
        return throwError(err);
      }));
  }
}
